var _rect, _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMoimir = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  rx: 4,
  fill: "#397ED3"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 22.375l1.452-2.188M10.903 18l-1.451 2.188m0 0c.87.937 3.658 2.812 7.838 2.812 4.181 0 6.494-2.048 7.075-3.09M23.096 18L26 22.375",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 12.5,
  r: 1.5,
  fill: "#fff"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.5,
  cy: 12.5,
  r: 1.5,
  fill: "#fff"
})));
export { SvgMoimir as ReactComponent };